import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { formatWithTimezone } from 'src/libs/util'
import styles from 'src/styles/ActionContainer.module.css'

const ActionContainer = ({ actions, learnDate }) => {
  const [open, setOpen] = useState(false)
  const handleToggle = () => {
    setOpen(!open)
  }
  // const actionsLog = actions.filter(action => Array.isArray(action?.sessions) && action?.sessions?.length > 0)
  if (!actions.length) {
    return (
      <span
        className='d-block'
        style={{
          color: '#ff0000'
        }}
      >
        {/*HS chưa được tạo kế hoạch can thiệp tháng {getDateFormatMonth(learnDate)}*/}
        Chưa có kế hoạch can thiệp
      </span>
    )
  }
  return (
    <div>
      <div className={styles.header}>
        <span className={styles.headerTitle}>{actions.length} hành động</span>
        <span className={`${styles.toggleIcon} ${open ? styles.open : ''}`} onClick={handleToggle}>
         <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
              d='M15 8L10 13L5 8'
              stroke='#6B7280'
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
         </svg>
        </span>
      </div>
      <ul className={styles.actionList}>
        {
          open && (
            actions.map((action, idx) => (
              <ActionDetail key={idx} action={action} />
            ))
          )
        }
      </ul>
    </div>
  )
}
const ActionDetail = ({ action }) => {
  const { t } = useTranslation()
  const { type, interventionContent, sessions = [] } = action || {}
  const status = sessions?.length > 0 ? sessions[0]?.status : null
  const statusText = status ? (status === 'TODO' ? 'Chưa hoàn thành' : 'Đã hoàn thành') : null
  const isCompleted = status !== 'TODO'
  const statusClass = isCompleted ? styles.statusCompleted : styles.statusInProgress
  return (
    <li className={styles.actionItem}>
      <div className={styles.actionTitle}>
        {/*<span className={styles.actionTitleLabel}>{t(`constant.type_rule_engine.${type}`)}:</span>*/}
        <span className={styles.actionTitleText}> {interventionContent}</span>
      </div>
      {
        sessions.length > 0 && (
          <>
            <div className={styles.actionStatus}>
              <span className={`${styles.statusText} ${statusClass}`}>
                {statusText}
              </span>
              <span className={styles.separator}>•</span>
              <span>{sessions[0]?.userUpdated?.userName}: {formatWithTimezone(sessions[0]?.updatedAt, 'dd/MM/yyyy HH:mm')}</span>
            </div>
          </>
        )
      }
    </li>
  )
}

export default ActionContainer
